import { render, staticRenderFns } from "./EmployeeDetail.vue?vue&type=template&id=607f438a&"
import script from "./EmployeeDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports